/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
export const title = (year: number, text: string) => {
  return (
    <h1>
      {year} <span className="red"> {text}</span>
    </h1>
  );
};

export const participants = (number: number, text: string) => {
  return (
    <h2>
      Deelnemers ({number}): <span className="red">{text}</span>
    </h2>
  );
};

export {};
